import { useState } from 'react';
import { apiJson } from '../api/client.js';
import { FormInput, SearchForm } from './FormControls.jsx';
import { AssetLibraryList } from './AssetLibraryList.jsx';

/**
 * @param {{ endpoint: string; showMeta?: boolean; projectId?: number }} props
 */
export function AssetLibraryAiSearch({ endpoint, showMeta = true, projectId }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const search = async (e) => {
    e.preventDefault();
    const q = query.trim();
    if (!q) return;
    setLoading(true);
    setError('');
    try {
      const body = { q };
      if (projectId) body.project_id = projectId;
      const res = await apiJson(endpoint, { method: 'POST', body });
      setResults(res);
    } catch (err) {
      setError(err.message);
      setResults(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginBottom: '1rem' }}>
      <SearchForm onSubmit={(e) => void search(e)}>
        <FormInput
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="AI search — describe what you need…"
        />
        <button type="submit" className="btn-secondary" disabled={loading}>
          {loading ? 'Searching…' : 'AI search'}
        </button>
      </SearchForm>
      {error ? <p className="err small">{error}</p> : null}
      {results?.error ? <p className="muted small">{results.error}</p> : null}
      {results ? (
        <>
          <p className="muted small">
            {results.items?.length
              ? `${results.items.length} match${results.items.length === 1 ? '' : 'es'} for “${results.query}”`
              : `No matches for “${results.query}”`}
          </p>
          <AssetLibraryList items={results.items ?? []} showMeta={showMeta} projectId={projectId} />
        </>
      ) : null}
    </div>
  );
}
